/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PromotionResponseDTO interface.
 */
export function instanceOfPromotionResponseDTO(value) {
    return true;
}
export function PromotionResponseDTOFromJSON(json) {
    return PromotionResponseDTOFromJSONTyped(json, false);
}
export function PromotionResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'promotionId': json['promotionId'] == null ? undefined : json['promotionId'],
        'promotionType': json['promotionType'] == null ? undefined : json['promotionType'],
        'couponType': json['couponType'] == null ? undefined : json['couponType'],
        'status': json['status'] == null ? undefined : json['status'],
        'percentOff': json['percentOff'] == null ? undefined : json['percentOff'],
        'amountOff': json['amountOff'] == null ? undefined : json['amountOff'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'budgetType': json['budgetType'] == null ? undefined : json['budgetType'],
        'budgetValue': json['budgetValue'] == null ? undefined : json['budgetValue'],
        'selectionType': json['selectionType'] == null ? undefined : json['selectionType'],
        'qualifiesForPricing': json['qualifiesForPricing'] == null ? undefined : json['qualifiesForPricing'],
    };
}
export function PromotionResponseDTOToJSON(json) {
    return PromotionResponseDTOToJSONTyped(json, false);
}
export function PromotionResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'promotionId': value['promotionId'],
        'promotionType': value['promotionType'],
        'couponType': value['couponType'],
        'status': value['status'],
        'percentOff': value['percentOff'],
        'amountOff': value['amountOff'],
        'currency': value['currency'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'budgetType': value['budgetType'],
        'budgetValue': value['budgetValue'],
        'selectionType': value['selectionType'],
        'qualifiesForPricing': value['qualifiesForPricing'],
    };
}
